import { restore as _restore } from '../../actions/authentication';
import { changeView as _changeView } from '../../actions/view';
import { restoreErrorSelector, restoreStatusSelector, viewStateEmailSelector } from './selectors';
import { RestoreFormContainer as Component } from './RestoreFormContainer';
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    initialEmail: viewStateEmailSelector(state),
    error: restoreErrorSelector(state),
    status: restoreStatusSelector(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    restore: function restore(email) {
      dispatch(_restore({
        email: email
      }));
    },
    changeView: function changeView(view) {
      dispatch(_changeView(view));
    }
  };
}

export var RestoreFormContainer = connect(mapStateToProps, mapDispatchToProps)(Component);